function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIdCardSvgrepoCom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 392.533 392.533",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M32.711,103.596c-6.012,0-10.925,4.848-10.925,10.925v204.8c0,6.012,4.848,10.925,10.925,10.925 h327.111c6.012,0,10.925-4.848,10.925-10.925V114.457c0-6.012-4.848-10.925-10.925-10.925"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#56ACE0"
    },
    d: "M327.176,125.382H65.422c-12.024,0-21.786,9.762-21.786,21.786v139.313 c0,12.024,9.762,21.786,21.786,21.786h261.754c12.024,0,21.786-9.762,21.786-21.786V147.168 C348.962,135.143,339.2,125.382,327.176,125.382z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 173.64,
    y: 62.352,
    style: {
      fill: "#FFC10D"
    },
    width: 45.253,
    height: 57.406
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#194F82"
    },
    d: "M314.182,190.61H218.44c-6.012,0-10.925-4.848-10.925-10.925c0-6.012,4.848-10.925,10.925-10.925 h95.741c6.012,0,10.925,4.848,10.925,10.925C325.107,185.697,320.194,190.61,314.182,190.61z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#194F82"
    },
    d: "M314.182,241.875H218.44c-6.012,0-10.925-4.848-10.925-10.925c0-6.012,4.848-10.925,10.925-10.925 h95.741c6.012,0,10.925,4.848,10.925,10.925C325.107,236.962,320.194,241.875,314.182,241.875z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#194F82"
    },
    d: "M314.182,293.204H218.44c-6.012,0-10.925-4.849-10.925-10.925c0-6.012,4.848-10.925,10.925-10.925 h95.741c6.012,0,10.925,4.848,10.925,10.925C325.107,288.291,320.194,293.204,314.182,293.204z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFC10D"
    },
    d: "M158.448,181.042h-58.311c-6.012,0-10.925,4.848-10.925,10.925v68.525 c0,6.012,4.848,10.925,10.925,10.925h58.311c6.012,0,10.925-4.848,10.925-10.925v-68.525 C169.374,185.956,164.525,181.042,158.448,181.042z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#194F82"
    },
    d: "M158.448,159.192h-58.311c-18.036,0-32.711,14.675-32.711,32.711v68.525 c0,18.036,14.675,32.711,32.711,32.711h58.311c18.036,0,32.711-14.675,32.711-32.711v-68.525 C191.16,173.931,176.549,159.192,158.448,159.192z M169.374,260.428c0,6.012-4.848,10.925-10.925,10.925h-58.311 c-6.012,0-10.925-4.849-10.925-10.925v-68.525c0-6.012,4.848-10.925,10.925-10.925h58.311c6.012,0,10.925,4.848,10.925,10.925 V260.428z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#194F82"
    },
    d: "M359.822,81.81H240.679V51.426c0-6.012-4.848-10.925-10.925-10.925h-67.038 c-6.012,0-10.925,4.848-10.925,10.925V81.81H32.711C14.675,81.81,0,96.42,0,114.521v204.8c0,18.036,14.675,32.711,32.711,32.711 h327.111c18.036,0,32.711-14.675,32.711-32.711V114.457C392.533,96.42,377.859,81.81,359.822,81.81z M173.64,62.352h45.253v57.406 H173.64V62.352L173.64,62.352z M370.747,319.257c0,6.012-4.848,10.925-10.925,10.925H32.711c-6.012,0-10.925-4.848-10.925-10.925 v-204.8c0-6.012,4.848-10.925,10.925-10.925h119.143v16.226h-1.681c-6.012,0-10.925,4.848-10.925,10.925 c0,6.012,4.848,10.925,10.925,10.925h92.186c6.012,0,10.925-4.848,10.925-10.925c0-6.012-4.848-10.925-10.925-10.925h-1.681 v-16.226h119.143c6.012,0,10.925,4.848,10.925,10.925V319.257L370.747,319.257z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIdCardSvgrepoCom);
export default __webpack_public_path__ + "static/media/id-card-svgrepo-com.e92fd78c5692b4540ac4a096874bb047.svg";
export { ForwardRef as ReactComponent };